import React, { Fragment, useCallback, useEffect, useState } from "react";
import PageBannerComponent from "../Components/Common/PageBannerComponent";
import AuthLayout from "../Layout/AuthLayout";
import {
  useGetNotificationMutation,
  useReadAllNotificationsMutation,
} from "../Store/api/DataApi";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../Store";
import { actionCount } from "../Store/slices/NotificationSlice";
import NotificationItemComponent from "../Components/Notifications/NotificationItemComponent";

export default function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [getNotification, { data }] = useGetNotificationMutation();
  const [readAllNotification] = useReadAllNotificationsMutation();
  const { id } = useSelector((state: RootState) => state.auth.profile);
  const dispatch = useDispatch();

  useEffect(() => {
    if (data?.data) {
      setNotifications(data?.data?.notifications);
      readAllNotification({
        user_type: "2",
        user_id: String(id),
      });
      dispatch(actionCount(0));
    }
  }, [data, setNotifications, dispatch]);

  const fetchNotification = useCallback(() => {
    let params = {
      user_type: "2",
      user_id: String(id),
    };
    getNotification(params);
  }, [getNotification, id]);

  useEffect(() => {
    fetchNotification();
  }, []);

  return (
    <Fragment>
      <PageBannerComponent title="My Notifications" />
      <AuthLayout>
        <div className="job-alerts-item">
          {notifications.length > 0 ? (
            notifications.map((noti, i) => (
              <NotificationItemComponent item={noti} key={i} />
            ))
          ) : (
            <>No notification found</>
          )}
          {/* <div className="notification-item">
            <div className="thums">
              <img
                src={require("../Assets/img/post.png")}
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="text-left">
              <p>
                Your Bookmarked job "Web designer needed" from Banana Inc, has
                expired.
              </p>
              <span className="time">
                <i className="fa fa-clock-o" />3 Hours ago
              </span>
            </div>
          </div>
          <div className="notification-item">
            <div className="thums">
              <img
                src={require("../Assets/img/post.png")}
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="text-left">
              <p>
                Your Bookmarked job "Web designer needed" from Banana Inc, has
                expired.
              </p>
              <span className="time">
                <i className="fa fa-clock-o" />3 Hours ago
              </span>
            </div>
          </div>
          <div className="notification-item">
            <div className="thums">
              <img
                src={require("../Assets/img/post.png")}
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="text-left">
              <p>
                Your Bookmarked job "Web designer needed" from Banana Inc, has
                expired.
              </p>
              <span className="time">
                <i className="fa fa-clock-o" />3 Hours ago
              </span>
            </div>
          </div>
          <div className="notification-item">
            <div className="thums">
              <img
                src={require("../Assets/img/post.png")}
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="text-left">
              <p>
                Your Bookmarked job "Web designer needed" from Banana Inc, has
                expired.
              </p>
              <span className="time">
                <i className="fa fa-clock-o" />3 Hours ago
              </span>
            </div>
          </div>
          <div className="notification-item">
            <div className="thums">
              <img
                src={require("../Assets/img/post.png")}
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="text-left">
              <p>
                Your Bookmarked job "Web designer needed" from Banana Inc, has
                expired.
              </p>
              <span className="time">
                <i className="fa fa-clock-o" />3 Hours ago
              </span>
            </div>
          </div>
          <div className="notification-item">
            <div className="thums">
              <img
                src={require("../Assets/img/post.png")}
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="text-left">
              <p>
                Your Bookmarked job "Web designer needed" from Banana Inc, has
                expired.
              </p>
              <span className="time">
                <i className="fa fa-clock-o" />3 Hours ago
              </span>
            </div>
          </div> */}
        </div>
      </AuthLayout>
    </Fragment>
  );
}
